import React, { RefObject, useEffect } from 'react';
import 'twin.macro';
import { Menu } from 'components/Menu';
import { newEmptyAtelier } from 'containers/CahierJournal/EventModal/ModalBody/Ateliers/AteliersForm';
import { useEleveGroups } from 'queries/eleveGroups/useEleveGroups';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';

interface Props {
  cycle: string;
  onClose?: () => void;
  ateliersRef?: RefObject<HTMLDivElement>;
  onAddToSeanceCallback?: () => void;
}

export function AtelierMenuItems(props: Props) {
  const { cycle, onClose, onAddToSeanceCallback } = props;
  const { data: eleveGroups } = useEleveGroups();
  const { t } = useTranslation(['common', 'cahierJournal']);
  const ateliersField = useField<Date>('ateliers');

  useEffect(
    () => () => {
      if (onClose) {
        onClose();
      }
    },
    [],
  );
  return (
    <>
      <div tw="text-xs text-neutral-quiet font-semibold px-4 py-2">
        {t('cahierJournal:ateliers.modal.howMany')}
      </div>
      {[2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(i => (
        <Menu.Item
          key={`add-ateliers-${i}`}
          onClick={() => {
            const newAteliers = Array.from({ length: i }).map((_, ii) => {
              let supervision = 'Autonomie';
              if (ii === 0) {
                supervision = 'Dirigé';
              }
              if (ii === 1) {
                supervision = 'Semi-dirigé';
              }

              const groupId =
                (eleveGroups || []).length > 0 &&
                ii < (eleveGroups || []).length
                  ? (eleveGroups || [])[ii].id
                  : undefined;

              return newEmptyAtelier({
                title: t('cahierJournal:ateliers.modal.defaultAtelierTitle', {
                  count: ii + 1,
                }),
                cycle,
                supervision,
                groupId,
                position: ii + 1,
              });
            });
            ateliersField.input.onChange(newAteliers);
            // Wait for the next render cycle before scrolling
            setTimeout(() => {
              if (props.ateliersRef?.current) {
                props.ateliersRef.current.scrollIntoView({
                  behavior: 'smooth',
                });
              }
            }, 0);
            onAddToSeanceCallback?.();
          }}
          text={t('cahierJournal:ateliers.modal.count', { count: i })}
        />
      ))}
    </>
  );
}
